import CONSTANTS from '@/constants/Config.constants'
import { IProviderIconService } from '../IProviderIconService'

const ICONS: any = CONSTANTS.ARTIFACTS.PROVIDERS_ICONS
const PATH = '/img/adapter-icons/'

export default class ProviderIconService implements IProviderIconService {
  getIconForProvider(provider: string): string | undefined {
    const icon = ICONS[provider]
    return icon ? `${PATH}${icon}` : undefined
  }
}
